export const CREATE_SALE = 'CREATE_SALE';
export const CREATE_SALE_ERROR = 'CREATE_SALE_ERROR';
export const CREATE_SALE_REQUEST = 'CREATE_SALE_REQUEST';
export const CREATE_SALE_SUCCESS = 'CREATE_SALE_SUCCESS';

export const DELETE_SALE = 'DELETE_SALE';
export const DELETE_SALE_ERROR = 'DELETE_SALE_ERROR';
export const DELETE_SALE_REQUEST = 'DELETE_SALE_REQUEST';
export const DELETE_SALE_SUCCESS = 'DELETE_SALE_SUCCESS';

export const DELETE_TRANSACTION_SALE = 'DELETE_TRANSACTION_SALE';
export const DELETE_TRANSACTION_SALE_ERROR = 'DELETE_TRANSACTION_SALE_ERROR';
export const DELETE_TRANSACTION_SALE_REQUEST =
  'DELETE_TRANSACTION_SALE_REQUEST';
export const DELETE_TRANSACTION_SALE_SUCCESS =
  'DELETE_TRANSACTION_SALE_SUCCESS';

export const EDIT_CUSTOM_SALE = 'EDIT_CUSTOM_SALE';
export const EDIT_CUSTOM_SALE_ERROR = 'EDIT_CUSTOM_SALE_ERROR';
export const EDIT_CUSTOM_SALE_REQUEST = 'EDIT_CUSTOM_SALE_REQUEST';
export const EDIT_CUSTOM_SALE_SUCCESS = 'EDIT_CUSTOM_SALE_SUCCESS';

export const EDIT_SALE = 'EDIT_SALE';
export const EDIT_SALE_ERROR = 'EDIT_SALE_ERROR';
export const EDIT_SALE_REQUEST = 'EDIT_SALE_REQUEST';
export const EDIT_SALE_SUCCESS = 'EDIT_SALE_SUCCESS';

export const GET_SALE = 'GET_SALE';
export const GET_SALE_ERROR = 'GET_SALE_ERROR';
export const GET_SALE_REQUEST = 'GET_SALE_REQUEST';
export const GET_SALE_SUCCESS = 'GET_SALE_SUCCESS';

export const GET_SALES = 'GET_SALES';
export const GET_SALES_ERROR = 'GET_SALES_ERROR';
export const GET_SALES_REQUEST = 'GET_SALES_REQUEST';
export const GET_SALES_SUCCESS = 'GET_SALES_SUCCESS';

export const MARK_PAID_SALE = 'MARK_PAID_SALE';
export const MARK_PAID_SALE_ERROR = 'MARK_PAID_SALE_ERROR';
export const MARK_PAID_SALE_REQUEST = 'MARK_PAID_SALE_REQUEST';
export const MARK_PAID_SALE_SUCCESS = 'MARK_PAID_SALE_SUCCESS';

export const RECEIVE_SALE = 'RECEIVE_SALE';
export const RECEIVE_SALE_ERROR = 'RECEIVE_SALE_ERROR';
export const RECEIVE_SALE_REQUEST = 'RECEIVE_SALE_REQUEST';
export const RECEIVE_SALE_SUCCESS = 'RECEIVE_SALE_SUCCESS';

export const SET_SALE = 'SET_SALE';
export const SET_SALES = 'SET_SALES';
